<template>
  <div :class="componentClasses">
    <Icon
      v-if="icon"
      class="stk-box-head-icon"
      :icon="icon"
    />
    <p class="stk-box-head-title">
      <slot />
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

defineProps({
  icon: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-box-head',
]);
</script>

<style>
.stk-box-head {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.stk-box-head-icon {
  color: var(--stk-primary);
}

.stk-box-head-title {
  color: var(--stk-text-strong);
  font-size: 1.125em;
  font-weight: 600;
  line-height: 1.25;
}
</style>
